import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=4cb92d48&scoped=true&"
import script from "./CategoryCard.vue?vue&type=script&lang=js&"
export * from "./CategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=4cb92d48&prod&lang=scss&scoped=true&"
import style1 from "./CategoryCard.vue?vue&type=style&index=1&id=4cb92d48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb92d48",
  null
  
)

export default component.exports